import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-disabled-user-page',
  templateUrl: './disabled-user-page.component.html',
  styleUrls: ['./disabled-user-page.component.scss']
})
export class DisabledUserPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
